import { GridFilterItem } from '@mui/x-data-grid-pro';
import { CustomFilterOperator } from '../columnsFactory/customFilters/operators/constants';
import { getDateRangeFilterFn } from '../columnsFactory/customFilters/dateRange/getDateRangeFilterFn';
import {
  DateRangeValue,
  isDateRangeType,
} from 'components/common/dateRangePicker';
import { DateFilterOperator } from './operators';

export function matchesDateFilter(
  operator: DateFilterOperator,
  filterValue: DateRangeValue | null | undefined,
  cellValue: Date | null,
  timezone: string
): boolean {
  if (
    (operator === CustomFilterOperator.DATE_RANGE ||
      operator === CustomFilterOperator.DATE_RANGE_PICKER) &&
    isDateRangeType(filterValue)
  ) {
    const dateFilterItem: GridFilterItem = {
      field: '',
      value: filterValue,
      operator,
    };

    const apply = getDateRangeFilterFn(
      dateFilterItem,
      timezone
    );
    return apply ? apply(cellValue) : true;
  }
  return true;
}
